<template>
  <database-management-modal :element="opportunity" ref="modal">
    <template v-slot:body>
      <div :class="hasErrorClass($v.opportunity.name, 'form-group')">
        <label class="control-label">* Name</label>

        <input
          name="name"
          type="text"
          class="form-control"
          placeholder="Guest speaking"
          v-model="$v.opportunity.name.$model" />

        <vuelidate-help :field="$v.opportunity.name" label="Name" />
      </div>
      <div :class="hasErrorClass($v.opportunity.appearance_type, 'form-group')">
        <label class="control-label">* Appearance Type</label>

        <selectize
          class="selectize selectize-single form-control"
          name="appearance_type"
          :options="appearanceTypeOptions"
          v-model="$v.opportunity.appearance_type.$model"
          :disable-delete="true">
        </selectize>

        <vuelidate-help :field="$v.opportunity.appearance_type" label="Appearance Type" />
      </div>
      <div :class="hasErrorClass($v.opportunity.field_set, 'form-group')">
        <label class="control-label">Field Set</label>

        <selectize
          class="selectize selectize-single form-control"
          name="field_set"
          :options="fieldSetOptions"
          v-model="$v.opportunity.field_set.$model"
          :disable-delete="true">
        </selectize>

        <vuelidate-help :field="$v.opportunity.field_set" label="Field Set" />
      </div>
      <div :class="hasErrorClass($v.opportunity.optional_fields, 'form-group')">
        <label class="control-label">Optional Fields</label>

        <selectize
          class="selectize selectize-multiple form-control"
          multiple
          placeholder="None"
          name="optional_fields"
          :options="optionalFieldOptions"
          v-model="$v.opportunity.optional_fields.$model"
          :disable-delete="true">
        </selectize>

        <vuelidate-help :field="$v.opportunity.optional_fields" label="Optional Fields" />
      </div>
      <div :class="hasErrorClass($v.opportunity.category_id, 'form-group')">
        <label class="control-label">Category</label>

        <selectize
          class="selectize selectize-single form-control"
          name="category"
          :options="categoryOptions"
          v-model="$v.opportunity.category_id.$model"
          :disable-delete="true">
        </selectize>

        <vuelidate-help :field="$v.opportunity.category_id" label="Category" />
      </div>
      <div v-if="selectedCategory && selectedCategory.currency === 'points' && $opportunityPointsModuleEnabled" :class="hasErrorClass($v.opportunity.points, 'form-group')">
        <label class="control-label">* Points</label>

        <div class="input-group">
          <span class="input-group-addon">{{ moneySymbol }}</span>
          <input
            name="name"
            type="text"
            class="form-control"
            placeholder="Points"
            v-model="$v.opportunity.points.$model" />
        </div>

        <vuelidate-help :field="$v.opportunity.points" label="Points" />
      </div>
      <div v-if="(budgetRequired || !selectedCategory) && $opportunityBudgetsModuleEnabled" :class="hasErrorClass($v.opportunity.budget, 'form-group')">
        <label class="control-label"><span v-if="budgetRequired">* </span>Value</label>

        <div class="input-group">
          <span class="input-group-addon">{{ moneySymbol }}</span>
          <input
            name="name"
            type="text"
            class="form-control"
            placeholder="1"
            v-model="$v.opportunity.budget.$model" />
        </div>

        <vuelidate-help :field="$v.opportunity.budget" label="Value" />
      </div>
    </template>
    <template v-slot:footer>
      <ladda-button :click="saveOpportunity" type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Save</ladda-button>
    </template>
  </database-management-modal>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import Selectize from '../../ext/codium/CodiumSelectize'
import getSymbolFromCurrency from 'currency-symbol-map'
import { http, notify } from 'utils'
import DatabaseManagementModal from './templates/DatabaseManagementModal'
export default {
  components: {DatabaseManagementModal, VuelidateHelp, Selectize},

  props: {
    opportunity: {
      required: true
    },
    categories: {
      required: true
    },
    offer: {
      required: false
    }
  },

  data () {
    return {
      appearanceTypeNoOfferOptions: [
        { id: 'in_person', text: 'In person' },
        { id: 'online', text: 'Online' },
        { id: 'both', text: 'Both' }
      ],
      appearanceTypeOfferOptions: [
        { id: 'in_person', text: 'In person' },
        { id: 'online', text: 'Online' },
        { id: 'both', text: 'Both' },
        { id: 'offer', text: 'Offer' }
      ],
      fieldSetOptions: [
        { id: 0, text: 'None' },
        { id: 'attend_event', text: 'Attend Event' },
        { id: 'video_message', text: 'Video Message' },
        { id: 'guest_speaking', text: 'Guest Speaking' },
        { id: 'skills_clinic', text: 'Skills Clinic' },
        { id: 'social_post', text: 'Social Post' },
        { id: 'ambassador', text: 'Ambassador' },
        { id: 'marketing_campaign', text: 'Marketing Campaign' }
      ],
      optionalFieldOptions: [
        { id: 'duration', text: 'Duration' },
        { id: 'themes', text: 'Themes' }
      ]
    }
  },

  computed: {
    appearanceTypeOptions () {
      return this.offer ? this.appearanceTypeOfferOptions : this.appearanceTypeNoOfferOptions
    },
    categoryOptions () {
      return this.categories.map(element => { return { id: element.id, text: element.name } })
    },
    selectedCategory () {
      if (this.opportunity.category_id) {
        return this.categories.find(element => element.id === this.opportunity.category_id)
      }
      return null
    },
    budgetRequired () {
      return this.selectedCategory && this.selectedCategory.currency && this.selectedCategory.currency !== 'points'
    },
    moneySymbol () {
      if (this.selectedCategory && this.selectedCategory.currency) {
        const currency = this.selectedCategory.currency
        if (currency === 'points') {
          return 'Pts'
        }
        return getSymbolFromCurrency(currency)
      }
    }
  },

  methods: {
    hasErrorClass (field, classes) {
      return field.$error ? `${classes} has-error` : `${classes}`
    },

    closeModal () {
      this.$refs.modal.closeModal()
    },

    saveOpportunity () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }
      const endpoint = this.opportunity.id ? `opportunities/${this.opportunity.id}/update` : 'opportunities/create'
      return http.put(endpoint, this.opportunity).then((response) => {
        if (!this.opportunity.id) {
          this.$emit('create', response.data)
        } else {
          this.$emit('update', response.data)
        }
        this.closeModal()
      })
    }
  },

  validations: {
    opportunity: {
      name: {
        required
      },
      appearance_type: {
        required
      },
      field_set: {},
      optional_fields: {},
      category_id: {},
      points: {
        required: requiredIf(function (model) {
          return this.selectedCategory && this.selectedCategory.currency === 'points' && this.$opportunityPointsModuleEnabled
        })
      },
      budget: {
        required: requiredIf(function (model) {
          return this.budgetRequired && this.$opportunityBudgetsModuleEnabled
        })
      }
    }
  }
}
</script>
